import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaInstagram, FaLinkedin, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import TermsAndConditionsModal from '../user/TermsAndConditionsModal';
import { useState } from 'react';
import config from '../../config';

const Footer = () => {
    const brandColor = '#b5430f';
    const [showTCModal, setShowTCModal] = useState(false);

    return (
        <>
            <footer style={{ backgroundColor: '#f8f9fa', borderTop: `4px solid ${brandColor}`, paddingTop: '3rem', paddingBottom: '1rem', marginTop: 'auto' }}>
                <Container>
                <Row>
                    {/* Información de la Empresa */}
                    <Col md={4} className="mb-4">
                        <h5 style={{ color: brandColor, fontWeight: 'bold' }}>{config.company.name}</h5>
                        <p className="text-muted">
                            Tu mejor opción para el hogar. Calidad y servicio en cada detalle para transformar tus espacios.
                        </p>
                        <div className="d-flex flex-column">
                            {/*<Link to="/contact" className="text-decoration-none text-secondary mb-2 hover-link">Contáctanos</Link>*/}
                            {/*<Link to="/careers" className="text-decoration-none text-secondary mb-2 hover-link">Trabaja con nosotros</Link>*/}
                            <Link to="/quienes-somos" className="text-decoration-none text-secondary mb-2 hover-link">Quiénes somos</Link>
                            <Link to="/partners" className="text-decoration-none text-secondary hover-link">Vende en HomeSanty</Link>
                        </div>
                    </Col>

                    {/* Información de Contacto */}
                    <Col md={4} className="mb-4">
                        <h5 style={{ color: brandColor, fontWeight: 'bold' }}>Contáctanos</h5>
                        <ul className="list-unstyled text-secondary">
                            <li className="mb-3 d-flex align-items-start">
                                <FaMapMarkerAlt className="me-2 mt-1" style={{ color: brandColor }} />
                                <span>{config.company.address}</span>
                            </li>
                            <li className="mb-3 d-flex align-items-center">
                                <FaPhone className="me-2" style={{ color: brandColor }} />
                                <span>{config.company.phone}</span>
                            </li>
                            <li className="mb-3 d-flex align-items-center">
                                <FaEnvelope className="me-2" style={{ color: brandColor }} />
                                <span>{config.company.email}</span>
                            </li>
                        </ul>
                    </Col>

                    {/* Redes Sociales y Legal */}
                    <Col md={4} className="mb-4">
                        <h5 style={{ color: brandColor, fontWeight: 'bold' }}>Síguenos</h5>
                        <p className="text-muted">Mantente al día con nuestras ofertas y novedades.</p>
                        <div className="d-flex gap-3 mb-4">
                            <a href={config.social.facebook} target="_blank" rel="noreferrer" className="text-secondary fs-4 social-icon"><FaFacebook /></a>
                            <a href={config.social.instagram} target="_blank" rel="noreferrer" className="text-secondary fs-4 social-icon"><FaInstagram /></a>
                            <a href={config.social.linkedin} target="_blank" rel="noreferrer" className="text-secondary fs-4 social-icon"><FaLinkedin /></a>
                        </div>
                        <div>
                            <button
                                type="button"
                                onClick={() => setShowTCModal(true)}
                                className="btn btn-link p-0 me-3 align-baseline text-decoration-none small"
                                style={{ color: brandColor }}
                            >
                                Política de Privacidad
                            </button>
                            <button
                                type="button"
                                onClick={() => setShowTCModal(true)}
                                className="btn btn-link p-0 align-baseline text-decoration-none small"
                                style={{ color: brandColor }}
                            >
                                Términos de Uso
                            </button>
                        </div>
                    </Col>
                </Row>

                <hr style={{ borderColor: brandColor, opacity: 0.2 }} />

                <Row>
                    <Col className="text-center py-3 text-muted small">
                        <p className="mb-0">
                            &copy; {new Date().getFullYear()} {config.company.name}, una colaboración de Comercial Santy y Prospect. Todos los derechos reservados.
                        </p>
                    </Col>
                </Row>
                </Container>
                <style>
                    {`
                    .hover-link:hover {
                        color: ${brandColor} !important;
                        text-decoration: underline !important;
                    }
                    .social-icon:hover {
                        color: ${brandColor} !important;
                        transform: translateY(-3px);
                        transition: all 0.3s ease;
                    }
                `}
                </style>
            </footer>
            <TermsAndConditionsModal
                show={showTCModal}
                handleClose={() => setShowTCModal(false)}
            />
        </>
    );
};

export default Footer;
